<template>
  <div class="AirportBus">
    <ld-header>{{ $t('Q016','机场大巴') }}</ld-header>

    <p class="pd10">
      可查看机场大巴时刻表的城市
    </p>

    <div class="city-wrap">
      <div
        class="city-item"
        v-for="City in cityList"
        :key="City.id"
        @click="detail(City)"
      >
        {{ City.cityName }}
      </div>
    </div>
  </div>
</template>

<script>
import { openWebview } from '@/common/utils/plus'

export default {
  components: {
  },
  name: 'AirportBus',
  data () {
    return {
      cityList: [],
      city: {}
    }
  },
  created () {
    this.getList()
  },
  methods: {
    async getList() {
      const { data = [] } = await this.$api['common/airportBus']()
      this.cityList = data
    },
    detail (city) {
      openWebview(city.linkUrl, 'airortbus')
    }
  }
}
</script>

<style lang="less">
.AirportBus {
  h3 {
    margin: 0;
  }

  .pd10 {
    padding: 10px;
  }

  .pad8 {
    padding: 8px;
  }

  .city-wrap {
    flex-wrap:wrap
  }

  .city-item {
    display: inline-block;
    width: 2.05rem;
    padding: 10px 0;
    margin: 5px .2rem;
    text-align: center;
    border: 1px solid @color-text-black;
  }

  .bus-detail {
    iframe {
      width: 100%;
      height: calc(100vh - 50px);
      border: 0;
    }
  }

}
</style>